import { useParams } from "react-router-dom";
import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { tabs } from "./evaluationsTabs";
import { DetailTabs } from "../../components/detailTabs/DetailTabs";
import { EntityForm } from "../../components/entityForm/EntityForm";
import { Groups } from "../../components/groups/Groups";
import { evaluationsOptions } from "./evaluationsOptions";
import { actions } from "./evaluationActions";
import { EvaluationHeader } from "./EvaluationHeader";
import { RecordsRelated } from "../../components/recordsRelated/RecordsRelated";
import { eegRecordingOptions } from "../eeg-recording/eegRecordingOptions";

export const evaluationsFieldsQuery = [
    "*.*",
    "client.user_id.*",
    "treatment.client.*",
    "treatment.client.clinic_id.name",
    "treatment.client.user_id.*",
    "treatment.sessions.service.id",
    "treatment.sessions.status",
    "treatment.sessions.start_date",
    "evaluation_sent_by.user_id.*",
    "evaluation_done_by.user_id.*",
    "report_checked_by.user_id.*",
    "brain_maps_technician.user_id.*",
    "brain_maps_technician.user_id.technician_id.signature",
    "brain_maps_technician.user_id.technician_id.main_professional_title",
    "brain_maps_technician.user_id.technician_id.license_number",
    "report_session.technician.user_id.technician_id.signature",
    "report_session.technician.user_id.technician_id.main_professional_title",
    "report_session.technician.user_id.technician_id.license_number",
    "treatment.intake_form_adult.laterality",
    "treatment.intake_form_adult.date_created",
    "treatment.intake_form_child.laterality",
    "treatment.intake_form_child.date_created",
    "ec_images.*",
    "eo_images.*",
    "instrument_responses.instruments_responses_id.id",
    "instrument_responses.instruments_responses_id.completed_at",
    "instrument_responses.instruments_responses_id.instrument_id.name",
    "eeg_session.service.id",
    "eeg_session.service.name",
    "eeg_session.technician.user_id.*",
    "report_session.service.id",
    "report_session.service.name",
    "report_session.technician.user_id.*",
].join(",");

const EvaluationUpdateForm = () => {
    const { id } = useParams();
    return (
        <Record
            key={id}
            entity="evaluations"
            fieldsQuery={evaluationsFieldsQuery}
            type="update"
            body={<EntityForm groupsOptions={evaluationsOptions.groupsOptions} />}
        />
    );
};

export const evaluationRoutes = [
    {
        path: "/evaluations",
        element: <Records entity="evaluations" fieldsQuery={evaluationsFieldsQuery} options={evaluationsOptions} />,
    },
    {
        path: "/evaluations/:id",
        element: (
            <Record
                entity="evaluations"
                type="detail"
                fieldsQuery={evaluationsFieldsQuery}
                header={<EvaluationHeader actions={actions} />}
                body={<DetailTabs tabs={tabs} />}
            />
        ),
        children: [
            {
                path: "/evaluations/:id/detail",
                element: <Groups groupsOptions={evaluationsOptions.groupsOptions} />,
            },

            {
                element: (
                    <RecordsRelated
                        entity="eeg_recording"
                        fieldsToQuery="*.*,eeg_evaluation.eeg_session.start_date,eeg_evaluation.eeg_session.treatment.client.client_id"
                        fieldToFilter="eeg_evaluation"
                        recordsOptions={eegRecordingOptions}
                    />
                ),
                path: "/evaluations/:id/eeg_recording",
            },
        ],
    },
    {
        path: "/evaluations/:id/update",
        element: <EvaluationUpdateForm />,
    },
    {
        path: "/evaluations/create",
        element: (
            <Record
                entity="evaluations"
                fieldsQuery={evaluationsFieldsQuery}
                type="create"
                body={<EntityForm groupsOptions={evaluationsOptions.groupsOptions} />}
            />
        ),
    },
];

export const eegRecordingRoutes = [
    {
        path: "/eeg_recording",
        element: (
            <Records
                entity="eeg_recording"
                fieldsQuery={"*.*,eeg_evaluation.eeg_session.start_date,eeg_evaluation.eeg_session.treatment.client.client_id"}
            />
        ),
    },
];
